module.exports = __webpack_public_path__ + "static/img/6-01.68d1e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/custDetail/6-01.png
// module id = bUpx
// module chunks = 1